import { render, staticRenderFns } from "./ViewDoctor.vue?vue&type=template&id=ae1faa40&scoped=true"
import script from "./ViewDoctor.vue?vue&type=script&lang=js"
export * from "./ViewDoctor.vue?vue&type=script&lang=js"
import style0 from "./ViewDoctor.vue?vue&type=style&index=0&id=ae1faa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1faa40",
  null
  
)

export default component.exports